/* @flow */

/*
 * these action strings belong into src/stores/pollBuilderCheckedoutPoll
 * but are extracted into this file because otherwise there would be
 * circular dependencies.
 * several of the pollBuilder* stores handle these actions.
 */

export const CHECKOUT_EXISTING_POLL = 'opinary/CHECKOUT_EXISTING_POLL'
export const CHECKOUT_NEW_POLL = 'opinary/CHECKOUT_NEW_POLL'
export const UPDATE_CHECKEDOUT_POLL = 'opinary/UPDATE_CHECKEDOUT_POLL'



// WEBPACK FOOTER //
// ./src/stores/pollBuilder.js